module.exports = __webpack_public_path__ + "img/evaluatedone.1be25463.svg";